export const SESSION_STORAGE = 'sessionStorage';
export const LOCAL_STORAGE = 'localStorage';

function getStorageType() {
  if (process.env.NODE_ENV === 'test') return null;
  const storage = window.localStorage && window.localStorage.getItem('storage');
  if (storage === LOCAL_STORAGE) return storage;
  return SESSION_STORAGE;
}

export function setStorageType(type) {
  if (process.env.NODE_ENV === 'test') return null;
  if (type !== LOCAL_STORAGE && type !== SESSION_STORAGE) return false;
  return window.localStorage.setItem('storage', type);
}

function getStorage() {
  if (process.env.NODE_ENV === 'test') return null;
  return window[getStorageType()];
}

export function setStorageItem(key, value) {
  if (process.env.NODE_ENV === 'test') return null;
  if (arguments.length !== 2 || typeof key !== 'string') return false;
  return getStorage().setItem(key, value);
}

export function getStorageItem(key, def = '') {
  if (process.env.NODE_ENV === 'test') return null;
  const storage = getStorage();
  return (storage && storage.getItem(key)) || def;
}

export function clearStorage() {
  if (process.env.NODE_ENV === 'test') return null;
  window.localStorage.clear();
  window.sessionStorage.clear();
}
